import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';
import { currencyInput } from '@/_schemas/generic';

import { campaignTypeFormSchema } from './campaign-type-options';
import { marketingCampaignQuerySchema } from './marketing-campaigns-query-schema';

export const marketingCampaignFormSchema = marketingCampaignQuerySchema
  .omit({
    contacts_count: true,
  })
  .extend({
    date: z.string(),
    notes: z.string(),
    total_cost_of_campaign: currencyInput.formSchema(),
    campaign_type: campaignTypeFormSchema,
    attached_files: z.array(fileQuerySchema),
  });

export type MarketingCampaignFormSchema = z.infer<typeof marketingCampaignFormSchema>;
